export default {
  ApiErrors: {
    generic: 'An error occurred. Please reload the page and contact us if the problem persists.',
    'Email already exists': 'Email not available',
    'This field is required.': 'This field is required',
    'First_name must be filled': 'First name must be filled',
    'Password length must be over 8 characters': 'Password length must be over 8 characters',
    'Unable to login with the provided credentials': 'Unable to login with the provided credentials',
    'godson is already a customer': 'This email is already associated with a customer',
    'godson is in referral process': 'This email is already in the referral process',
    'Enter a valid email address': 'This is not a valid email address',
    'Email already in db': 'Email not available',
    'Not an email': 'Invalid email',
    'Reward is soldout': 'This reward is out of stock',
    'Reward can only be claimed once': 'You have already claimed this reward',
    'Reward is no longer valid': 'This reward is no longer valid',
    'Not enough points': 'You do not have enough points',
    'Account already in use': 'This account is already used by another user',
    'This instagram account does not exist on Instagram': 'This Instagram account does not exist',
    'social error': "Please enter your account {'@'}my_account",
    'required field': 'Please complete this field',
    'value error': 'The value entered is incorrect',
    'You already applied a discount code': 'You have already applied a discount code'
  },
  Error: {
    generic: 'An error occurred, please reload the page.',
    link: 'Reload the page',
    title: 'Loyoly - Oops! Error',
    blacklistMessage1: 'You are not eligible for the loyalty program.',
    blacklistMessage2: 'Contact the support team if you think this is a mistake.'
  },
  FormEmail: {
    example: "johndoe{'@'}gmail.com",
    errors: {
      email: 'Please enter a valid email address',
      emailEmpty: 'Please enter your email address'
    }
  },
  InApp: {
    message: 'For an optimal experience, please use your default browser'
  },
  Phone: {
    countrySelector: {
      placeholder: 'Country code',
      error: 'Please choose a country',
      searchPlaceholder: 'Select a country'
    },
    phoneInput: {
      placeholder: 'Phone number',
      example: 'Example:'
    },
    error: {
      invalid: 'Please enter a valid phone number'
    }
  },
  Instagram: {
    ModalNotLinked: {
      title: 'Connect to my Instagram account',
      subtitle: 'How it works',
      description: 'Please enter your Instagram account and ensure it is public before completing missions.',
      form: {
        username: 'Instagram account',
        usernameExample: "{'@'}johndoe"
      },
      errors: {
        usernameEmpty: 'Please enter your account name',
        usernameNotFound: 'Please enter a valid account name'
      },
      button: 'Validate'
    },
    ModalSearching: {
      title: 'We are searching for your account'
    },
    ModalLinked: {
      title: 'Connect to my Instagram account',
      private: {
        subtitle: 'Unable to connect with your account',
        description: {
          title: 'Your Instagram account is private',
          text: 'Oops, it looks like your Instagram account is private. Set it to public to access all missions.'
        }
      },
      public: {
        subtitle: 'Successfully connected with your account',
        description: {
          title: 'Congratulations',
          text: 'You can now complete missions.'
        }
      },
      buttons: {
        edit: 'Edit my account',
        retry: 'Retry',
        goback: 'Return to the page',
        gotoChallenge: 'Go to the mission'
      }
    },
    ModalNotFound: {
      title: 'Connect to my Instagram account',
      subtitle: 'Unable to connect with your account',
      description: {
        title: 'Account not found',
        text: 'We invite you to change accounts or contact support.'
      },
      buttons: {
        change: 'Change account',
        retry: 'Retry'
      }
    }
  },
  Modal: {
    Notifications: {
      title: 'Email notifications',
      information: {
        title: 'Information',
        text: 'If you do not wish to receive mission reminders, news, or reward reminders, you can unsubscribe by disabling the checkboxes below:'
      },
      communication: {
        optinTransactional: 'Promotional: information about the program, VIP levels, rewards',
        optinMarketing: 'Informative: information about purchases and sponsorship.'
      }
    },
    SocialAccount: {
      Info: {
        public: 'Public account',
        private: 'Private account',
        followers: '<span class="weglot-ignore">{n}</span> follower | <span class="weglot-ignore">{n}</span> followers'
      }
    }
  },
  Points: '<span class="weglot-ignore">{n}</span> point | <span class="weglot-ignore">{n}</span> points',
  PointsDecimal: '<span class="weglot-ignore">{value}</span> point | <span class="weglot-ignore">{value}</span> points',
  SectionHeader: {
    poweredBy: 'Powered by'
  },
  SectionChallenges: {
    empty: 'There are no missions available in your loyalty program',
    showAll: 'Show all',
    ModalMissionDetail: {
      description: 'Description',
      pointsToEarn: 'Points to earn',
      howto: 'How it works?',
      uploadMedia: 'Upload your media',
      reviewApplication: 'Leave a review',
      linkApplication: 'Download the app',
      newsletterPartners:
        'By clicking on "Validate the mission", you agree to receive commercial offers from the company by electronic means.',
      phonePartners: 'I agree that my phone number may be used to receive SMS offers.',
      clue: 'Clue',
      linkPage: 'View the page',
      instaMention: 'Tag',
      tiktokMention: 'Tag',
      instaHashtags: 'Hashtag(s) to use',
      tiktokHashtags: 'Hashtag(s) to use',
      linkToShare: 'Link to include in your story',
      linkShare: 'Link to share',
      vouchertoShare: 'Promotional code to share',
      goToAccount: 'Go to the account',
      goToInsta: 'Go to the account',
      goToInstaPost: 'Go to the Instagram post',
      goToInstaReel: 'Go to the Instagram reel',
      goToInstaIGTV: 'Go to the Instagram IGTV',
      goToTweeterTweet: 'Go to the Tweet',
      goToReview: 'Leave a review',
      goToShop: 'Go to the store',
      goToLink: 'Go to the page',
      goToTypeform: 'Complete the form',
      goToWhatsapp: 'Join Group',
      submit: 'Validate the mission',
      missionPendingTitle: 'Mission under verification',
      missionPendingExplain: 'Your points will be credited soon.',
      actionSurveyTextError: 'Please select an answer',
      actionEmailError: 'Your email is not valid',
      actionInputError: 'This field is not valid',
      actionInputImageError: 'Please upload your media',
      handlingMedia: 'Processing media',
      errorMediaHandle: 'An error occurred while processing your media',
      imageInvalid: 'An error occurred while processing your media',
      videoSize: 'The size of your video must be less than 100 MB.',
      errorInstaReel: 'The URL of your reel is incorrect',
      'This url is not a valid google url': 'The URL of your Google review is invalid',
      'This url is not a valid reel url': 'The URL of your reel is incorrect',
      refusalReasonCondition: 'Non-compliance with conditions',
      refusalReasonQuality: 'Quality too low',
      refusalReasonContent: 'Inappropriate content',
      refusalReasonSound: 'Inaudible sound',
      missionInvalidTitle: 'Mission invalidated',
      missionInvalidDescription: 'You can redo the mission by carefully following the required rules',
      missionInvalidReasons: 'Reason for refusal:',
      condition: 'Conditions',
      conditionExplanation: 'Have more than',
      ineligible: 'Ineligible',
      ineligibleExplanation:
        'It seems you do not have the required number of followers. If you have more followers, we invite you to update your account information.',
      lastUpdate: 'Last update on',
      updateAccount: 'Update my account',
      reviewLastPurchase: 'Leave a review on the product page of your last purchase',
      whenReviewValidated: 'Once the review is validated, your mission will be automatically validated',
      pointsToEarnPhoto: 'Extra points for a photo',
      pointsToEarnVideo: 'Extra points for a video',
      howtoBirthdate: 'Enter your birthdate',
      errorInvalidDate: 'Please enter a valid date',
      inputMedia: 'Upload your media',
      inputMediaLoaded: 'Your media has been uploaded',
      placeholderAnswer: 'Write your answer here',
      misteryAnswer: 'What is the mystery word?',
      newsletterEmail: 'Confirm your email address',
      birthDate: 'Birthdate',
      example: 'Example',
      goToChallenge: 'Go to challenge'
    },
    ModalMissionImageRights: {
      imageRights:
        'By checking this box, I confirm that I am the author of the content, expressly agree to transfer the intellectual property rights associated with it, and authorize the use of my image by the brand for commercial purposes under the terms and conditions specified in ',
      imageRightsLink: 'this agreement.',
      title:
        'Agreement for the Transfer of Intellectual Property Rights on the Content and Authorization for the Use of My Personal Attributes.',
      content:
        'I expressly agree that the publication of the content created as part of my assignment (the “Content”):',
      bullet1:
        'constitutes a transfer, in favor of the brand, of all related copyright, worldwide, for the entire legal duration of copyright protection, on an exclusive and final basis. I acknowledge that this transfer is granted in exchange for the points earned as part of my assignment, which constitute fair consideration. This transfer includes the right to reproduce and display the Content by the brand, in whole or in part, on all media and by all means, existing or future, foreseeable or unforeseeable, as well as the right to translate, arrange, modify, adapt, and/or edit the Content by the brand, alone or in collaboration with a third party. I undertake that this Content does not infringe the rights of third parties or constitute an act of infringement, and I guarantee the brand against any such claims;',
      bullet2:
        'constitutes an authorization granted to the brand, free of charge, to fix, reproduce, distribute, and publicly communicate my personal attributes associated with the Content, on all media and by all known or unknown means, foreseeable or unforeseeable, and across all platforms, networks, and distribution channels, for purposes of exploitation, information, communication, promotion, and advertising of the brand’s products, for a period of 10 years, which may be extended by mutual agreement.',
      end1: 'This agreement is governed by French law and shall be construed in accordance with it.',
      end2: 'Any dispute that may arise regarding its validity, interpretation, or execution shall fall under the exclusive jurisdiction of the Courts of Paris, unless otherwise required by procedural rules.'
    },
    ModalMissionLoyaltyDetail: {
      pointsToEarn:
        '<span class="weglot-ignore">{points}</span> point to earn for every <span class="weglot-ignore">{amountToPoints}</span> spent | <span class="weglot-ignore">{points}</span> points to earn for every <span class="weglot-ignore">{amountToPoints}</span> spent',
      orderNumber: 'Order No.',
      orderDate: 'Date',
      orderAmount: 'Amount',
      orderRewardable: 'Rewardable',
      orderPoints: 'Points earned',
      orderPaid: 'Validated',
      orderStatus: 'Status',
      orderCancel: 'Refunded',
      orderRefund: 'Partially refunded',
      orderWaiting: 'Pending'
    },
    CompanyConditions: {
      seeTermsAndConditions: 'See conditions',
      seePrivacy: 'See privacy policy'
    }
  },
  SectionProfile: {
    socialNetworks: {
      instagram: 'Connect to Instagram',
      tiktok: 'Connect to TikTok'
    },
    notificationsByEmails: 'Email notifications',
    cgu: 'Terms and conditions'
  },
  SectionAccountRewards: {
    empty: 'There are no more rewards to exchange and you have no rewards pending use',
    copied: 'Copied!'
  },
  SectionRewards: {
    empty: 'There are no rewards available in your loyalty program',
    showAll: 'Show all',
    Card: {
      channel_store: 'In store',
      channel_online: 'Online',
      channel_both: 'Online and in store'
    }
  },
  SectionRewardsModalMyRewards: {
    title: 'My rewards',
    empty: 'You do not have any rewards yet.',
    emptyTip: 'You can complete missions and exchange your earned points for rewards',
    use: 'Use',
    expired: 'Expired'
  },
  SectionRewardsDetailInfos: {
    expireDate: 'Expiration date',
    expirationDelayExplain:
      'The reward will be usable for <span class="weglot-ignore">{expiration_delay}</span> days once you have exchanged it.',
    minimumBuy: 'Minimum purchase',
    maxAmount: 'Valid up to',
    description: 'Description',
    saleChannel: 'Sales channel',
    channelStore: 'In store',
    channelOnline: 'Online',
    channelBoth: 'Online and in store'
  },
  SectionRewardsDetailModal: {
    exchange: 'Exchange',
    errorMessage1: 'It seems that a problem has occurred.',
    errorMessage2: 'Your reward has not been exchanged and your points have not been deducted.',
    errorMessage3: 'Please reload the page.',
    errorButton: 'Reload the page'
  },
  SectionRewardsClaimModal: {
    howItWorks: 'How it works?',
    howItWorkCode: 'Use your code on our website when placing your order',
    howItWorkCodePOS: 'Present your code directly in store when you check out.',
    howItWorkCodeCMSPOS:
      'Use your code on our website when placing your order, or present it directly in store when checking out.',
    howItWorkCodeProduct: 'Add the product to your cart then use your code when placing your order',
    howItWorkCodeRecharge: 'Add the code directly into your client portal',
    howItWorkExt: 'You will be contacted to receive your reward',
    applyToBasket: 'Apply to cart',
    apply: 'Apply',
    applied: 'Applied',
    link: 'Link to the product',
    copied: 'Copied!',
    customerPortal: 'Customer portal',
    nonApplicable: 'Not eligible'
  },
  SectionRewardsDetailsRechargeSubscriptions: {
    apply: 'Apply',
    nonApplicable: 'Not eligible',
    itemTitle: '{title} / {price}',
    customerPortal: 'Customer portal'
  },
  SectionReferral: {
    friendEmail: 'Your friend’s email',
    seeReferral: 'See my referrals',
    errors: {
      emailSelf: 'The email entered is the same as your email'
    },
    Tabs: {
      link: 'Link',
      email: 'E-mail',
      sms: 'SMS',
      copy: 'Copy link',
      smsSend: 'Send a message',
      reward1: '{amount} points',
      reward2: '{amount}% discount',
      reward3: '{amount} voucher',
      smsTemplate:
        'Hello! I discovered {brand_name} which you might like.\n\n By using my referral link {referral_link}, you will benefit from {reward_friend}.\n\nTake advantage of it, it’s a really interesting offer!\nSee you soon!'
    },
    Modal: {
      emptyState: 'You have not made any sponsorships at the moment',
      title: 'My sponsorships',
      status: 'Status',
      email: 'Email',
      date: 'Expiry date',
      statusPending: 'Waiting',
      statusUsed: 'Already used',
      statusAvailable: 'Available',
      statusExpired: 'Expired',
      statusInvalidate: 'Invalidated',
      promocodeComing: 'Coming soon',
      promocodeUnavailable: '-',
      promocodeInvalidate: 'Invalidated',
      points_given: 'Your points have been credited',
      referral_type_3: 'Voucher',
      referral_type_2: 'Promotional code',
      referral_type_1: 'Points'
    },
    NotAuthenticatedForm: {
      emailPlaceholder: 'Email',
      emailError: 'The email format is not correct',
      emailEmpty: 'Please fill out this field',
      emailUnknown: 'Please create an account to refer'
    }
  },
  SectionVipTiersProgress: {
    you: 'You',
    points: 'points'
  },
  SectionVipTiersCard: {
    rewardPoints: '{points} points offered',
    rewardMultiplier: 'Point multiplier: x{multiplier}',
    tiersPoints: '{amount} points'
  },
  SectionGifting: {
    empty: 'There are no product tests available at the moment',
    showAll: 'Show all',
    ModalApply: {
      endDate: 'Application end date',
      description: 'Description',
      completeForm: 'Complete the form to submit your application',
      button: 'Apply',
      success: {
        title: 'Product test registration',
        description:
          'Thank you for completing your information. Your application is currently being reviewed. You will be notified by email.'
      },
      Form: {
        Errors: {
          required: 'Please complete this field',
          date: 'Please enter a valid date'
        }
      }
    },
    ModalParticipate: {
      challenges: 'Missions',
      howItWorks: 'How does it work?',
      useCode: 'Use your code on our website when ordering.',
      youWillBeContacted: 'You will be contacted to collect your product.',
      buttonLink: 'Link to product',
      buttonCopied: 'Copied!'
    }
  },
  SectionGiftingCardList: {
    status: {
      participate: 'Participate',
      underValidation: 'In progress',
      apply: 'Apply',
      ended: 'Finished',
      rejected: 'Application not accepted'
    }
  },
  SectionSteps: {
    Authenticated: {
      month: '{n} month| {n} months'
    },
    ModalActivities: {
      title: 'My recent activities',
      empty: "You don't have any recent activities yet.",
      table: {
        header: {
          title: 'Title',
          points: 'Points',
          date: 'Date'
        }
      },
      events: {
        challenge: 'Mission validated',
        order: 'Purchase made',
        reward: 'Reward obtained',
        refferal: 'Sponsorship validated',
        userAction: 'Adjusted points',
        level: 'Level reached',
        levelLabel: 'Level {level}',
        reset: 'Points expiration',
        automation: 'Points earned'
      }
    }
  },
  Tiktok: {
    ModalNotLinked: {
      title: 'Login to my TikTok account',
      subtitle: 'How it works',
      description:
        'Please fill out your Tiktok account, making sure it is public. You will then be able to carry out Tiktok missions.',
      button: 'Link my account'
    },
    ModalLinked: {
      title: 'Login to my TikTok account',
      subtitle: 'Login with your account successful',
      congratulations: 'Congratulations',
      description: 'You can now complete the missions.',
      buttons: {
        edit: 'Modify my account',
        goback: 'Return to page'
      }
    }
  },
  SectionReferralFriend: {
    placeholder: 'Email address',
    emailError: 'Please enter a valid email address',
    emailEmpty: 'Please enter your email address',
    disclaimer: 'This offer is only valid for new customers',
    disclaimerVerification: 'You will not be contacted for commercial purposes.',
    referral_type_3: 'Voucher',
    referral_type_2: 'Promo code',
    referral_type_1: 'Points',
    copied: 'Copied!',
    label_optin_reminder: 'I want to receive a reminder if I do not use my discount.',
    btn_optin_reminder: 'Receive a reminder for my code'
  },
  Unsubscribe: {
    title: 'Do you really want to unsubscribe from our loyalty program emails?',
    description:
      'If so, please note that you will no longer receive information about your rewards, missions, and points.',
    email: 'Email',
    button: 'Update my preferences',
    question: 'What type of emails would you like to receive:',
    optinTransactional: 'Program: communications related to new missions, completed missions, and the program',
    optinMarketing: 'Informative: information about purchases and sponsorship.',
    successTitle: 'Your preferences have been updated',
    successDescription: 'Use the button below to review or modify your preferences',
    successButton: 'Update my preferences',
    errorTitle: 'There is an error with the redirect link',
    errorButton: 'Redirect to the website'
  },
  SectionAccount: {
    copied: 'Copied!'
  },
  SectionPointCard: {
    you: 'You',
    copied: 'Copied!'
  }
}
